export enum ButtonType {
  DARK = 'dark',
  LIGHT = 'light',
  BLUE = 'blue',
  SUCCESS = 'success',
  LINK = 'link',
}
